<template>
  <div class="base_panel">
    <div class="panel_title">Enter coupon code</div>
    <div class="memo">If you have a coupon code, enter it here.</div>
    <div class="input_area">
      <input type="text" v-model="couponCode" />
      <BlackGradationButton class="bay-button" text="Use Coupon" @handleSquareBtnClick="clickCouponCode" />
    </div>
    <div class="alert_message">{{couponCodeError}}</div>
    <div class="alert">
      *If there is a coupon currently applied, the new coupon will be overwritten.
      <br>
      Please note that the old coupon will become invalid.
    </div>
    <div>*coupon codes will be sent out regularly via SNS and email.</div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BlackGradationButton from '@/components/atoms/BlackGradationButton.vue';

export default {
  components: {
    BlackGradationButton,
  },

  computed: {
    ...mapGetters({
      resultCouponUseError: 'coupon/resultCouponUseError',
    }),
  },

  data: () => ({
    couponCode: '',
    couponCodeError: '',
  }),

  created() {
    const query = window.location.search;
    const params = new URLSearchParams(query);
    const code = params.get('code');
    if (code) {
      this.couponCode = code;
    }
  },

  watch: {
    resultCouponUseError(val) {
      this.couponCodeError = val;
      if (!val) {
        window.location.href = '/buy-point';
      }
    },
  },

  methods: {
    clickCouponCode() {
      this.$store.dispatch('coupon/useCoupon', { couponCode: this.couponCode });
    },
  },
};
</script>

<style lang="scss" scoped>
.base_panel {
  margin-top: 10px;
  border-radius: 10px;
  background-color: #fff;
  padding: 20px 30px;
  color: #0020aa;
  font-weight: bold;
}
.memo {
  margin-left: 10px;
}
.panel_title {
  font-size: 28px;
  @media screen and (max-width: $tabletWidth) {
    text-align: center;
  }
}
.input_area {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 10px 0;
  @media screen and (max-width: $tabletWidth) {
    flex-direction: column;
  }
  input {
    border: solid 1px $deepColor;
    padding: 5px 10px;
    margin-right: 20px;
    @media screen and (max-width: $tabletWidth) {
      margin-right: 0;
      margin-bottom: 10px;
    }
  }
}
.bay-button {
  background-color: #0693ee;
  border-radius: 10px;
}
.alert_message {
  color: #c00;
  line-height: 16px;
  margin-bottom: 10px;
  white-space: pre-wrap;
}
.alert {
  color: #c00;
  line-height: 16px;
}
</style>
